import { type KyInstance } from 'ky';

import { handleRequest } from '@/utils/httpUtils';

import { GetCfdiUsesReq, GetFiscalRegimensReq } from './types';

export interface IReqCatalogs {
  getCfdiUses: GetCfdiUsesReq;
  getFiscalRegimens: GetFiscalRegimensReq;
}

export function reqCatalogs(http: KyInstance): IReqCatalogs {
  const route = 'api/user/catalogs';

  return {
    getCfdiUses: async () => handleRequest(http, 'get', `${route}/cfdi-uses`),
    getFiscalRegimens: async () => handleRequest(http, 'get', `${route}/fiscal-regimens`),
  };
}
